import { createFetchWithPolicy, FetchPolicyError } from '@emporion/ui'

const toEnvNumber = (
  key: 'NEXT_PUBLIC_API_TIMEOUT_MS' | 'NEXT_PUBLIC_API_RETRIES' | 'NEXT_PUBLIC_API_RETRY_DELAY_MS',
) => {
  const raw = process.env[key]
  if (!raw) return null
  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : null
}

const resolveDefaults = () => ({
  timeoutMs: toEnvNumber('NEXT_PUBLIC_API_TIMEOUT_MS') ?? 10_000,
  retries: toEnvNumber('NEXT_PUBLIC_API_RETRIES') ?? 1,
  retryDelayMs: toEnvNumber('NEXT_PUBLIC_API_RETRY_DELAY_MS') ?? 250,
})

export { FetchPolicyError }
export const fetchWithPolicy = createFetchWithPolicy({ resolveDefaults })

